import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  container: {
    [theme.breakpoints.up('lg')]: {
      paddingLeft: theme.spacing(8),
      paddingRight: theme.spacing(8),
    },
  },
  active: {
    backgroundColor: theme.palette.success.main,
    color: theme.palette.common.white,
  },
  inactive: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.common.white,
  },
  validating: {
    backgroundColor: theme.palette.statusLabel.pending.primary,
    color: theme.palette.common.white,
  },
  failed: {
    backgroundColor: theme.palette.statusLabel.error.primary,
    color: theme.palette.common.white,
  },
  platformChip: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
}))

export default useStyles
